import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported as isAnalyticsSupported } from "firebase/analytics";
import {
  browserLocalPersistence,
  getAuth,
  GoogleAuthProvider,
  setPersistence,
  signInWithPopup,
} from "firebase/auth";
import { getFirestore, doc, setDoc, serverTimestamp } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDbuBchaIU8FhyhxQMUYAuN00ZtcwPDSJk",
  authDomain: "manucalc-1d2b5.firebaseapp.com",
  projectId: "manucalc-1d2b5",
  storageBucket: "manucalc-1d2b5.firebasestorage.app",
  messagingSenderId: "757991238106",
  appId: "1:757991238106:web:fbd2f95ec8c5d04d17b8e3",
  measurementId: "G-NXK1WYD81Z",
};

const app = initializeApp(firebaseConfig);
if (typeof window !== "undefined") {
  isAnalyticsSupported()
    .then((supported) => {
      if (supported) getAnalytics(app);
    })
    .catch(() => {
      // Analytics is optional and should never delay or block the application.
    });
}

export const auth = getAuth(app);
export const authPersistenceReady = setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.warn("Firebase auth persistence could not be set to local persistence:", error);
});
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();

export const signInWithGooglePopup = () =>
  signInWithPopup(auth, googleProvider);

export const saveCalculation = async (toolId, params, results, userId) => {
  if (!userId) {
    console.error("User not authenticated");
    return null;
  }

  const calculationData = {
    id: Date.now().toString(),
    toolId,
    params,
    results,
    timestamp: serverTimestamp(),
    userId,
  };

  try {
    const docRef = doc(db, "calculations", calculationData.id);
    await setDoc(docRef, calculationData);
    return calculationData.id;
  } catch (error) {
    console.error("Error saving calculation:", error);
    return null;
  }
};

export default app;
